import { request } from "@weapp/utils";
import { mainHost } from "../utils";

const host = mainHost();

//获取团队分享数据
export const getTeamSharing = (data: any) => {
    return request({
        url: `/api/blog/teamshare/workdyna`,
        method: "POST",
        data,
    });
};

//发布团队分享
export const publish = (data: any) => {
    return request({
        url: `/api/blog/teamshare/publish`,
        method: "POST",
        data,
    });
};

//编辑团队分享
export const editAfterPublish = (data: any) => {
    return request({
        url: `/api/blog/teamshare/editAfterPublish`,
        method: "POST",
        data,
    });
};

//删除团队分享数据
export const deleteTeamSharing = (data: any) => {
    return request({
        url: `/api/blog/teamshare/deleteShare`,
        method: "POST",
        data,
    });
};

//保存团队分享设置
export const saveConfig = (data: any) => {
    return request({
        url: `/api/bcw/base/configuration/saveConfig`,
        method: "POST",
        data,
    });
};

//加载我关注的
export const loadMyfollow = (params: any) => {
    return request({
        url: `/api/hrm/user/myfollow/${window.TEAMS.currentUser.id}`,
        method: "get",
        params
    });
};

//加载我的下属
export const loadSubordinate = (params: any) => {
    return request({
        url: `/api/hrm/user/subordinate/${window.TEAMS.currentUser.id}`,
        method: "get",
        params
    });
};

//点赞
export const praise = (data: any) => {
    return request({
        url: `/api/blog/teamshare/praise`,
        method: "post",
        data
    });
};

//查询当前人员是否有邀请权限
export const checkInvitePermission = (formData: any) => {
    return request({
        url: `/api/bcw/base/configuration/existConfigRange`,
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: formData
    });
};


